<template>
  <div class="">
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Ledger</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-input placeholder="Search..." type="search" v-model="searchTerm" @input="customSearch(searchTerm)"></b-input>
          </div>
          <div class="level-item">
            <a class="button is-small is-link field" title="Filter" @click="toggleFilter = true">
              Apply Filter <b-icon icon="filter" size="is-small"></b-icon>
            </a>
          </div>
          <div class="level-item">
            <router-link :to="{ name: 'nodalView' }" class="button is-small is-link">Back to List </router-link>
          </div>
        </div>
      </div>
      <p>Brainbees</p>
    </section>

    <section class="section is-main-section">
      <div class="b-table">
        <table class="table is-bordered is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th rowspan="3" scope="col" width="20%">
                Company Name
              </th>
            </tr>
            <tr>
              <th scope="col" colspan="2">Opening</th>
              <th scope="col" colspan="2">Closing</th>
            </tr>
            <tr>
              <th>Cr</th>
              <th>Dr</th>
              <th>Cr</th>
              <th>Dr</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="obj in searchFilterArray" :key="obj.id">
              <td>
                <router-link
                  :to="{
                    name: 'ledgerDetail',
                    params: { franchiseeID: obj.id }
                  }"
                >
                  {{ obj.companyName || '-' }}
                </router-link>
              </td>
              <td>
                <span class="mdi mdi-currency-inr"></span>
                {{ obj.openingAmount !== null ? (obj.openingAmount.type === 'CREDIT' ? numberWithCommas(Number(obj.openingAmount.amount).toFixed(2)) : '0.00') : '0.00' }}
              </td>
              <td>
                <span class="mdi mdi-currency-inr"></span>
                {{ obj.openingAmount !== null ? (obj.openingAmount.type === 'DEBIT' ? numberWithCommas(Number(obj.openingAmount.amount).toFixed(2)) : '0.00') : '0.00' }}
              </td>
              <td>
                <span class="mdi mdi-currency-inr"></span>
                {{ obj.closingAmount !== null ? (obj.closingAmount.type === 'CREDIT' ? numberWithCommas(Number(obj.closingAmount.amount).toFixed(2)) : '0.00') : '0.00' }}
              </td>
              <td>
                <span class="mdi mdi-currency-inr"></span>
                {{ obj.closingAmount !== null ? (obj.closingAmount.type === 'DEBIT' ? numberWithCommas(Number(obj.closingAmount.amount).toFixed(2)) : '0.00') : '0.00' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <!-- filter modal -->
    <div class="modal" :class="{ 'is-active': toggleFilter }">
      <div class="modal-background"></div>
      <form class="modal-card" style="height: 350px;">
        <header class="modal-card-head">
          <p class="modal-card-title">Ledger Filter</p>
          <button class="delete" type="button" @click="toggleFilter = false"></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="getAllTransactions">

            <div class="column ">
                <div class="field">
                  <label class="label">
                    Select Franchisee <span class="has-text-danger"> * </span>
                    <span> <b-checkbox v-model="flag" @input="allFranchisee">Select All</b-checkbox></span>
                  </label>

                  <div class="control select is-fullwidth">
                    <multiselect class="overflowmultiselect1" label="companyName" track-by="companyName"
                      :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                      :preselect-first="false" :multiple="true" :options="franchiseeArr" :optionHeight="10"
                      v-model="franchisee" @remove="onTouch">
                      <template slot="selection" slot-scope="{ values, isOpen }"><span
                          class="multiselect__single" v-if="values.role &amp;&amp; !isOpen">{{
                            values.companyName }} </span></template>
                    </multiselect>
                  </div>
                </div>
              </div>
            <div class="form-row">
              <div class="right-pull-button">
                <button class="button is-success is-pulled-right" type="submit">Apply</button>
              </div>
            </div>
          </form>
        </section>
      </form>
    </div>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import server from '../../store/server'
import dialogError from '@/components/dialogError.vue'

export default {
  name: 'ledger',
  components: { Multiselect },
  data () {
    return {
      searchTerm: '',
      searchFilterArray: [],
      toggleFilter: false,
      selectedFranchisee: '',
      allTransactions: [],
      allFranchisees: [],
      loadingComponent: null,
      franchiseeArr: [],
      franchisee: [],
      flag: ''
    }
  },
  created () {
    this.getAllFranchisee()
    this.allFranchisee()
    this.getFranchiseeList()
  },
  methods: {
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.allTransactions
      } else {
        this.searchFilterArray = _.filter(this.allTransactions, function (item) {
          return item.companyName.toLowerCase().search(value.toLowerCase()) >= 0
        })
      }
    },
    numberWithCommas: function (value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getAllTransactions: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        if (_.isEmpty(this.franchisee)) {
          this.loadingComponent.close()
          return dialogError.ErrorMsg('Please select franchisee to fetch the report.', 'is-danger', this)
        }

        const formdata = {
          franchisee: _.map(this.franchisee, 'id')
        }

        let { data } = await server.post(`v1/transaction/franchisee/all`, this, formdata)

        this.allTransactions = data
        this.searchFilterArray = this.allTransactions

        this.toggleFilter = false
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.toggleFilter = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getAllFranchisee: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee`)
        this.allFranchisees = data.rows

        if (this.searchFilterArray.length === 0) {
          dialogError.ErrorMsg('Please select a filter option before fetching the data.', 'is-danger', this)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    closing: async function () {
      this.modalOk = false
      await this.onStart()
    },
    onTouch: function () {
      this.flag = false
      return true
    },
    allFranchisee: function () {
      let tempArray = []
      if (this.flag === true) {
        this.franchiseeArr.forEach(Obj => {
          tempArray.push(Obj)
        })
      }

      this.franchisee = tempArray
    },
    getFranchiseeList: async function (id) {
      this.loadingComponent = this.$buefy.loading.open()
      const data = await server.get('franchisee/active', this)
      this.loadingComponent.close()
      if (_.isEqual(data.success, 200)) {
        this.franchiseeArr = data.data.rows
      } else {
        this.loadingComponent.close()
        return dialogError.ErrorMsg(data.message, 'is-danger', this)
      }
    }
  }

}
</script>
<style scoped>
.is-large.modal-close,
.is-large.delete {
  visibility: hidden;
}

.buttons {
  flex-wrap: nowrap;
}
.right-pull-button{
  display: flex
;
    justify-content: flex-end;
    position: absolute;
    bottom: 40px;
    right: 40px;
}
.button .icon:first-child:last-child {
    margin-left: calc(0.5em - 6px);
    margin-right: calc(0.5em - 18px);
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
